import classNames from 'classnames';
import _, { floor, isNil, orderBy, reduce } from 'lodash';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Card, CardHeader } from 'reactstrap';
import { nodeModuleNameResolver } from 'typescript';
import { LoadingUnitIdentifier } from '.';
import { DeepPartialGraph } from '../types';
import { Handling, Terminal } from '../types/graph';

type StorageDataCardProps = {
    // @ts-ignore
    terminal: DeepPartialGraph<Terminal>
};




//const Rows = styled.ul`
//    display: flex;
//    flex-direction: column;
//    list-style-type: none;
//    padding: 0;
//`;

//const Row = styled(Link)<{ color: 'warning' | 'danger' }>(({ theme, color }) => {
//    const baseColor = new Color(theme[color]);
//    const bgColor = baseColor;
//    const lightBg = bgColor.luminosity() > .5;
//    const activeBgColor = bgColor[lightBg ? 'darken' : 'lighten'](.1);
//    const lightActiveBg = baseColor.luminosity() > .5;
//    const txtColor = lightBg === true ? theme.black : theme.white;
//    const activeTxtColor = lightActiveBg === true ? theme.black : theme.white;

//    return `
//    color: ${ txtColor };
//    background-color: ${ bgColor };
//    padding: .25rem .5em;
//    display: flex;
//    justify-content: space-between;

//    :hover {
//        color: ${ activeTxtColor};
//        background-color: ${activeBgColor };
//        text-decoration: none;
//    }
//`;
//});

const StorageDataCard = ({ terminal }: StorageDataCardProps) => {
    const { t } = useTranslation('common');
    const handlings = orderBy((terminal.handlings as DeepPartialGraph<Handling>[]), ['loadingUnitIdentifier'], ['asc']).filter(h => h.checkedIn === true && h.checkedOut !== true);
    const terminalSlug = terminal.slug;

    const [noDataHandlings, notAuthorizedHandlings] = useMemo(() => reduce(handlings, (acc, handling) => {
        if (isNil(handling.dangerousGoods) || handling.dangerousGoods.length === 0) {
            acc[0].push(handling);

            return acc;
        }

        if (isNil(handling.portAuthorityAuthorization) || handling.portAuthorityAuthorization.authorized === false) {
            acc[1].push(handling);

            return acc;
        }

        return acc;
    }, [[] as typeof handlings, [] as typeof handlings]), [handlings])

    const noDataTable = useMemo(() => {
        if (noDataHandlings.length === 0) {
            return null;
        }

        const cn = classNames({
            "list-group-item": true,
            "d-flex": true,
            "justify-content-between": true,
            "list-group-item-warning": true,
        })

        const rows = noDataHandlings.map(({ id, loadingUnitIdentifier }) => <Link className={cn} key={id} color='warning' to={`${terminalSlug}/unita-in-sosta/${loadingUnitIdentifier?.toLowerCase()}`}>
                    <LoadingUnitIdentifier identifier={loadingUnitIdentifier} />
                </Link>)

        return <Card>
            <CardHeader>
                <h4 className={'text-warning'}>
                    {t('Unità con dati mancanti')}
                </h4>
            </CardHeader>

            <div className="list-group list-group-flush">{rows}</div>
        </Card>
    }, [noDataHandlings])

    const notAuthorizedTable = useMemo(() => {
        if (notAuthorizedHandlings.length === 0) {
            return null;
        }

        const cn = classNames({
            "list-group-item": true,
            "d-flex": true,
            "justify-content-between": true,
            "list-group-item-danger": true,
        })

        const rows = notAuthorizedHandlings.map(({ id, loadingUnitIdentifier }) => <Link className={cn} key={id} color='danger' to={`${terminalSlug}/unita-in-sosta/${loadingUnitIdentifier?.toLowerCase()}`}>
            <LoadingUnitIdentifier identifier={loadingUnitIdentifier} />
        </Link>)

        return <Card>
            <CardHeader>
                <h4 className={'text-danger'}>
                    {t('Unità non autorizzate')}
                </h4>
            </CardHeader>

            <div className="list-group list-group-flush">{rows}</div>
        </Card>
    }, [notAuthorizedHandlings])

    const ok = noDataTable === null && notAuthorizedTable === null;
    //const ko = notAuthorizedTable !== null;

    const statusIndicator = ok === true
        ? <span className='text-success'>{t('OK')}</span>//OK
        : <span className='text-danger'>{t('KO')}</span>//OK

    return <>
        <h4>{t('Dati')}{' '}{statusIndicator}</h4>
        {notAuthorizedTable}
        {noDataTable}
    </>;
};


export default StorageDataCard;